


<template lang="jade">

	div.home

		div.branding
			img.logo(src="../../assets/img/nxtgen-logo-2x.png")
			div.tagline EXPERIENCE DRIVEN TECHNOLOGY

		div.menu
			div.menu-col
				a(href="mailto:info@nxtgen.online") REQUEST A DEMO
			div.menu-col
				a(href="https://app.nxtgen.online") LOGIN TO NXTSYS
			div.menu-col
				a(href="mailto:info@nxtgen.online") CONTACT US

		div.footer
			div &copy; {{ date }} NXTGEN. All rights reserved.
			div 181 University Ave #8, Toronto ON
			div M5H 3M7, Canada
			br
			router-link(to="/privacy") Privacy Policy

</template>



<script>



	let $cmp = {
		name : 'home'
	}



	$cmp.data = function() {
		return {
			date : new Date().getFullYear()
		}
	}



	$cmp.mounted = function() {

	}



	export default $cmp



</script>



<style lang="stylus">

	.home
		position relative
		width 100%
		height 100%
		color #FFFFFF
		overflow hidden

	.branding
		position absolute
		top 20%
		left 50%
		transform translate(-50%,0%)
		text-align center

	.logo
		display block
		width 270px
		height auto
		margin-bottom 15px

	.tagline
		width 100%
		color #B3BCC9
		font-size 12px
		font-weight 500
		font-family 'Work Sans', sans-serif
		letter-spacing 1px
		//opacity 0.45

	.menu
		position absolute
		display flex
		flex-wrap wrap
		width 100%
		max-width 900px
		bottom 20%
		left 50%
		transform translate(-50%,0%)

	.menu-col
		flex 1
		text-align center

		@media(max-width 499px)
			min-width 280px
			height 40px

		a
			display inline-block
			color #B3BCC9
			font-size 13px
			font-weight 500
			font-family 'Work Sans', sans-serif
			padding-bottom 1px
			border-bottom 1px solid transparent
			transition all 333ms

			&:hover
				color #FFFFFF
				border-bottom 1px solid #FFFFFF

	.footer
		position absolute
		width 280px
		bottom 30px
		left 50%
		transform translate(-50%, 0%)
		color #B3BCC9
		font-size 12px
		font-family 'Helvetica', 'Helvetica Neue', sans-serif
		line-height 140%
		text-align center
		opacity 0.33

		a
			display inline-block
			color #B3BCC9
			font-size 13px
			font-weight 500
			font-family 'Work Sans', sans-serif
			padding-bottom 1px
			border-bottom 1px solid transparent
			transition all 333ms

			&:hover
				color #FFFFFF
				border-bottom 1px solid #FFFFFF


</style>



// WEBPACK FOOTER //
// src/components/home/home.vue